import React from "react";
import "./GameDetailsListStyle.scss";
import { gameDetailsListTextContent } from "./constant/index";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const GameDetailsListSection = ({ gameDetailsList, showButtons }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate(`/contact-us`);
  };

  return (
    <section className="game-details-list-section">
      <div className="game-details-list-wrap">
        <ul className="list-text">
          {gameDetailsList?.map((detail, index) => (
            <li className="list-item" key={index}>
              <strong className="label-text">{detail.label}:</strong>{" "}
              <span className="text">{detail.value}</span>
            </li>
          ))}
        </ul>

        {showButtons && (
          <div className="btn-box">
            <CustomButton
              buttonType="primary"
              label={gameDetailsListTextContent.contactUsBtnText}
              onClick={handleButtonClick}
            />
            <CustomButton
              buttonType="primary"
              label={gameDetailsListTextContent.shareBtnText}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default GameDetailsListSection;
